import { render, staticRenderFns } from "./Refresh.vue?vue&type=template&id=27b6e8a0&scoped=true"
import script from "./Refresh.vue?vue&type=script&lang=js"
export * from "./Refresh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../usr/local/node_16.9.1/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b6e8a0",
  null
  
)

export default component.exports